<table mat-table [dataSource]="pureOriginals()"
       multiTemplateDataRows matSort matSortDisableClear [matSortDirection]="sortDirectionValues().direction"
       [matSortDisabled]="disableSortButton()"
       [matSortActive]="sortDirectionValues().active"
       (matSortChange)="changePureOriginalsTableSortDirection($event)"
       [ngClass]="{'no-sort-arrows': disableSortButton(), 'has-tuning-preview': enableTuningsPreview()}">

    <ng-container matColumnDef="tuningExpand">
        <th mat-header-cell *matHeaderCellDef><span class="visually-hidden">Matched tunings</span></th>
        <td mat-cell *matCellDef="let element">
            <button type="button" class="expand-tunings"
                    [disabled]="!element.id || +element.id <= 0"
                    [attr.aria-expanded]="expandedPureOriginalId() === +element.id"
                    [attr.aria-controls]="'po-tunings-' + element.id"
                    [attr.aria-label]="(expandedPureOriginalId() === +element.id ? 'Hide' : 'Show') + ' matched tunings for Pure Original ' + element.id"
                    (click)="toggleTunings(+element.id, $event)">
                <i class="bi" [class.bi-chevron-down]="expandedPureOriginalId() !== +element.id"
                   [class.bi-chevron-up]="expandedPureOriginalId() === +element.id" aria-hidden="true"></i>
            </button>
        </td>
    </ng-container>

    <ng-container matColumnDef="tuningDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="tableHeaders().length" [id]="'po-tunings-' + element.id">
            @if (enableTuningsPreview() && expandedPureOriginalId() === +element.id) {
                <app-pure-original-tunings-preview [pureOriginalId]="+element.id"></app-pure-original-tunings-preview>
            }
        </td>
    </ng-container>

    <mat-dialog-content>
        <ng-container *ngFor="let column of displayedOriginalColumns()" [matColumnDef]="column">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ column }}</th>
            <td mat-cell *matCellDef="let element"
                [ngClass]="{
                    'done': column === 'status' && element.status === 'DONE',
                    'waiting': column === 'status' && element.status === 'WAITING',
                    'in-progress': column === 'status' && element.status === 'IN_PROGRESS',
                    'error-text': column === 'status' && element.status === 'ERROR'
                }">
                {{ formatDate(element[column], column) | shorten: 25 }}
            </td>
        </ng-container>
    </mat-dialog-content>

    <mat-dialog-actions>
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
                <div [ngStyle]="{'display':'flex', 'justify-content': 'center', 'flex-direction':'row', 'gap': '10px', 'align-items': 'center'}">
                    Actions

                    @if (headerActionButton) {
                        <input
                                type="checkbox"
                                [id]="'select-all-checkbox'"
                                [checked]="isAllSelected()"
                                (change)="toggleSelectAll($event)">
                    }
                </div>
            </th>
            <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="actionsTemplate; else defaultActions">
                    <ng-container *ngTemplateOutlet="actionsTemplate; context: { $implicit: element }"></ng-container>
                </ng-container>

                <ng-template #defaultActions>
                    <button class="table-buttons"
                            (click)="deletePureOriginalItem(element, +element.id, 'PURE_ORIGINAL_BASE')">
                        <i class="bi bi-trash"></i>
                    </button>
                    <button class="table-buttons" [disabled]="!element.id"
                            (click)="openPureOriginalDetails(+element.id)">
                        <i class="bi bi-eye"></i>
                    </button>
                    <button *ngIf="authService.isAdmin()" class="table-buttons"
                            matTooltip="Upload Ini file" matTooltipPosition="below"
                            (click)="openPureOriginalUploadModal(element.id)">
                        <i class="bi bi-file-arrow-up"></i>
                    </button>
                </ng-template>
            </td>
        </ng-container>
    </mat-dialog-actions>

    <tr mat-header-row *matHeaderRowDef="tableHeaders()"></tr>

    @if (isLoadingTemplate()) {
        <tr >
            <td [attr.colspan]="tableHeaders().length" style="text-align: center; padding: 20px;">
                <mat-spinner diameter="50"></mat-spinner>
            </td>
        </tr>
    } @else {
        <tr mat-row *matRowDef="let element; columns: tableHeaders()" [class.tunings-expanded]="enableTuningsPreview() && expandedPureOriginalId() === +element.id"></tr>
        @if (enableTuningsPreview()) {
            <tr mat-row *matRowDef="let element; columns: ['tuningDetail']" class="tuning-detail-row"
                [class.tuning-detail-row--open]="expandedPureOriginalId() === +element.id"></tr>
        }
    }
</table>

@if (isModalOpened()) {
    <app-upload-file-dialog
            (isFileModalClosed)="fileModalClosed()"
            [title]="'Upload Pure Original Ini File'"
    >
        <div class="upload-file-container">
            <app-upload-file (file)="uploadIniFile($event)" [error]="pureOriginalsService.myInputs.get('ini').message"
                             [inputText]="pureOriginalsService.inputText" customBackground="var(--primary-nav-bg)"
                             [progressWidth]="pureOriginalsService.progressWidth()"
                             [resetSignal]="pureOriginalsService.resetSignal()"></app-upload-file>
        </div>
    </app-upload-file-dialog>
}
